import { theme } from '../../styles/theme';

export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super-admin',
  SALES_AGENT: 'sales-agent',
};

export const TYPE_STATISTICS = {
  general: 'true',
};

export const REQUESTS_PERIOD_OPTIONS = {
  thisYear: {
    value: 'thisYear',
    label: 'This Year',
  },
  all: {
    value: 'all',
    label: 'All Time',
  },
};

/*
  Contacts filters:
  ALL, CUSTOMERS, FORMER_CUSTOMERS
 */
export const CONTACTS_TYPE_FILTERS = {
  ALL: {
    value: 'ALL',
    title: 'All',
  },
  CUSTOMERS: {
    value: 'CUSTOMERS',
    title: 'Customers',
  },
  FORMER_CUSTOMERS: {
    value: 'FORMER_CUSTOMERS',
    title: 'Former Customers',
  },
};

/*
  Requests layouts:
  List, Kanban
 */
export const REQUESTS_LAYOUTS = {
  LIST: 'List',
  KANBAN: 'Kanban',
};

/*
  Tabs statuses:
  DONE, UNDONE
 */
export const TABS_STATUSES = {
  DONE: 'done',
  UNDONE: 'undone',
};

export const TASK_PRIORITIES = [
  { value: 'NO_PRIORITY', label: 'No priority', color: theme.colors.priorities.no },
  { value: 'LOW_PRIORITY', label: 'Low priority', color: theme.colors.priorities.low },
  { value: 'AVERAGE_PRIORITY', label: 'Average priority', color: theme.colors.priorities.average },
  { value: 'HIGH_PRIORITY', label: 'High priority', color: theme.colors.priorities.high },
];

/**
 * Default delay for data fetching (refreshing state)
 */
export const REFRESH_DATA_INTERVAL = 5500;

export const PROJECT_STATE = {
  OPPORTUNITY: 'opportunity',
  DELIVERING: 'delivering',
  DELIVERED: 'delivered',
  ARCHIVED: 'archived',
};

export const PROJECT_STATE_VALUE = {
  [PROJECT_STATE.OPPORTUNITY]: {
    value: 'opportunity',
    color: '#0C9D49',
  },
  [PROJECT_STATE.DELIVERING]: {
    value: 'delivering',
    color: '#2978D9',
  },
  [PROJECT_STATE.DELIVERED]: {
    value: 'delivered',
    color: '#FD740D',
  },
  [PROJECT_STATE.ARCHIVED]: {
    value: 'archived',
    color: '#FFD654',
  },
};



// WEBPACK FOOTER //
// ./src/api/constants/index.js